import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import arrow from '../../../content/media-library/download-purple.svg';

import CTAButton from '../ctaButton/CTAButton';

const Banner = ({ layout, title, text, list, image, type, customPadding, isOpen, colourScheme, bigTitle }) => {
  const [bannerOpen, setBannerOpen] = useState(isOpen === 'true');

  const componentClasses = classNames('banner banner--accordion', {
    [`banner--${layout}`]: layout,
    [`banner--${customPadding}`]: customPadding,
    [`banner--${type}`]: type,
    [`banner--${colourScheme}-scheme`]: colourScheme,
    [`banner--no-image`]: !image
  });

  const componentWrapperClasses = classNames('banner__wrapper', {
    'js-accordion-open': bannerOpen,
    'js-accordion-closed': !bannerOpen
  });

  return (
    <section className={componentClasses}>
      <div className={componentWrapperClasses}>
        <div className="banner__block">
          {image && <img src={image.src} alt={image.alt} />}
          <div className="banner__text-content">
            <div className="banner__dropdown">
              <h2>{title}</h2>
              <button
                onClick={() => setBannerOpen(!bannerOpen)}
                onKeyDown={(e) => e.key === 'Enter' || setBannerOpen(!bannerOpen)}
                className={bannerOpen ? 'banner__button banner__button--closed' : 'banner__button'}
              >
                <img src={arrow} alt="purple arrow" />
              </button>
            </div>
            {bigTitle && <p className="banner__big-title">{bigTitle}</p>}

            {text && type !== 'compact' && <p>{text}</p>}
          </div>
        </div>
        <ul className="banner__list">
          {list.map(({ type, text, link, linkStyle, colourScheme, className, openInNewTab = 'false' }) => {
            const linkClasses = classNames({
              [`linkstyle-${linkStyle}`]: linkStyle
            });
            return (
              <li key={text}>
                {type === 'CTAButton' ? (
                  <CTAButton {...{ text, link, colourScheme, className }} />
                ) : (
                  <a
                    href={link}
                    className={linkClasses}
                    {...(openInNewTab === 'true' ? { target: '_blank', rel: 'noopener noreferrer' } : null)}
                  >
                    {text}
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

Banner.propTypes = {
  layout: PropTypes.oneOf(['space-between', 'center']),
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  type: PropTypes.oneOf([null, 'compact', 'no-gutters']),
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-top-bottom']),
  list: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['text', 'CTAButton']),
      text: PropTypes.string,
      link: PropTypes.string,
      linkStyle: PropTypes.string,
      colourScheme: PropTypes.string,
      openInNewTab: PropTypes.string
    })
  ).isRequired,
  image: PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string }).isRequired,
  isOpen: PropTypes.string,
  colourScheme: PropTypes.oneOf(['sand', 'neutral-navy', 'dark-navy', 'white']),
  bigTitle: PropTypes.string
};

Banner.defaultProps = {
  layout: 'space-between',
  isOpen: 'false'
};

export default Banner;
